import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        template: '='
    },
    template: `
    <div class="heading01 type01">
        <h1>
            {{ vm.template.activeI18n.name }}
            <span ng-if="vm.template.sendIcalFile && vm.template.isIcalIncluded" class="badge">
                {{ 'notification.Notification is sent with an iCalendar file' | translate }}
            </span>
        </h1>
    </div>
    <div class="form nomargin ng-scope" ng-if="vm.template.isIcalIncluded">
        <div class="row">
            <span class="label">{{ 'notification.Send iCal file' | translate }}</span>
            <div class="items">
                <label class="switch01">
                    <input type="checkbox" ng-model="vm.checked">
                    <span>Yes</span>
                </label>
            </div>
        </div>
    </div>
     <form-wrapper ng-if="vm.template.sendIcalFile && vm.template.isIcalIncluded && vm.checked">
        <form-row error="vm.templateForm.errors.organizerName">
            <span class="label">{{ 'notification.Organizer name' | translate }}*</span>
            <div class="items">
                <input ng-model="vm.templateForm.model.organizerName" type="text" class="form-control">
            </div>
        </form-row>
        <form-row error="vm.templateForm.errors.organizerEmail">
            <span class="label">{{ 'notification.Organizer email' | translate }}*</span>
            <div class="items">
                <input ng-model="vm.templateForm.model.organizerEmail" type="text" class="form-control">
            </div>
        </form-row>
    </form-wrapper>
    <div class="form nomargin ng-scope" ng-if="vm.template.isOptionalModule">
        <div class="row">
            <span class="label">{{ 'notification.Send notification for optional trainings' | translate }}</span>
            <div class="items">
                <label class="switch01">
                    <input type="checkbox" ng-model="vm.checkedNotifications">
                    <span>Yes</span>
                </label>
            </div>
        </div>
    </div>
    <form-row class="txt">
        <div class="alert alert-plain">
            <p>{{ 'notification.allowed_tags' | translate }}:</p>
            <ul ng-repeat="variable in vm.allowedVariables">
                <li>{{ vm.getTag(variable) }}</li>
            </ul>
        </div>
        <div class="block02" ng-class="{ open: value.active === true }" ng-repeat="(key, value) in vm.form.model">
            <div class="heading01 heading01b">
                <label class="switch01">
                    <input
                        type="checkbox"
                        name="switch"
                        ng-model="value.active"
                        ng-disabled="vm.isCompanyLanguage(value.language)"
                        ng-change="vm.confirmDisablingTranslation(value)"
                    >
                    <span>Yes</span>
                </label>
                <h2 class="h3">{{ value.label }}</h2>
                <ul class="actions01">
                    <li><a class="btn view" ng-click="vm.preview(value)">{{ 'notification.Preview e-mail' | translate }}</a></li>
                    <li ng-if="vm.template.sendIcalFile && vm.template.isIcalIncluded && vm.checked">
                        <a class="btn view" ng-click="vm.previewNotification(value)">
                            {{ 'notification.Preview notification' | translate }}
                        </a>
                    </li>
                </ul>
            </div>
            <form-wrapper ng-if="value.active" form="vm.form">
                <form-row error="vm.form.errors[key].msgSubject">
                    <label class="label">{{ 'notification.E-mail subject' | translate }}*</label>
                    <div class="items">
                        <input ng-model="value.msgSubject" type="text" class="form-control">
                        <form-row-error></form-row-error>
                    </div>
                </form-row>
                <form-row error="vm.form.errors[key].msgBody">
                    <label class="label">{{ 'notification.E-mail content' | translate }}*</label>
                    <div class="items">
                        <div class="mt10">
                            <ng-ckeditor
                                class="mt10"
                                ng-model="value.msgBody"
                                ng-config="vm.ckconfig">
                            </ng-ckeditor>
                        </div>
                        <form-row-error></form-row-error>
                    </div>
                </form-row>
                <!-- future MVP
                <hr>
                <form-row error="vm.form.errors[key].msgWpNotificationBody">
                    <label class="label">Employee portal notification *</label>
                    <div class="items">
                        <textarea ng-model="value.msgWpNotificationBody" class="form-control"></textarea>
                        <form-row-error></form-row-error>
                    </div>
                </form-row>
                -->
                <form-row error="vm.form.errors[key].calenderContent" ng-if="vm.template.sendIcalFile && vm.template.isIcalIncluded && vm.checked">
                    <label class="label">{{ 'notification.Calendar invite content' | translate }}</label>
                    <div class="items">
                        <div class="mt10">
                            <ng-ckeditor
                                class="mt10"
                                ng-model="value.calenderContent"
                                ng-config="vm.ckconfig">
                            </ng-ckeditor>
                        </div>
                        <form-row-error></form-row-error>
                    </div>
                </form-row>
            </div>
        </div>
        <ul class="actions01">
            <li class="primary">
                <button class="btn main" type="button" ng-click="vm.save()">{{ 'general.Save' | translate }}</button>
            </li>
            <li>
                <a class="btn discrete" type="button" ui-sref="authorized.manage.templates.list">{{ 'general.Cancel' | translate }}</a>
            </li>
        </ul>
    </div>

    `
})
export default class {
    constructor ($translate, $state, FormFactory, CkEditorService, ModalService, TokenService, NotificationResource, toastr, lodash,
                 COMPANY_LANGUAGE_ENUM, NOTIFICATION_TRANSLATION_STATUS_ENUM) {
        this.$translate = $translate;
        this.$state = $state;
        this.lodash = lodash;
        this.FormFactory = FormFactory;
        this.CkEditorService = CkEditorService;
        this.ModalService = ModalService;
        this.TokenService = TokenService;
        this.NotificationResource = NotificationResource;
        this.toastr = toastr;
        this.COMPANY_LANGUAGE_ENUM = COMPANY_LANGUAGE_ENUM;
        this.NOTIFICATION_TRANSLATION_STATUS_ENUM = NOTIFICATION_TRANSLATION_STATUS_ENUM;

        this.ckconfig = this.CkEditorService.getNotificationConfig();
    }

    $onInit () {
        this.templateI18n = this.template.i18nInCompanyLang;
        this.companyLanguage = this.templateI18n.language;

        const templates = [];
        this.lodash.forEach(this.template.templateI18ns, (template, key) => {
            template.active = this.isActive(template.status);
            template.label = this.COMPANY_LANGUAGE_ENUM.LABELS[key.toUpperCase()];
            templates.push(template);
        });

        this.templateForm = this.FormFactory.createFromResource(this.template, {
            expand: 'templateI18ns'
        });

        this.form = this.FormFactory.create(
            this.sortTranslations(templates),
            model => this.NotificationResource.updateI18n(model).$promise
        );

        this.checked = !!this.templateForm.model.sendIcalFile;
        this.checkedNotifications = !!this.templateForm.model.sendNotificationsForOptionalModule;

        this.allowedVariables = Object.getOwnPropertyNames(this.templateI18n.variablesJson);
    }

    isActive (status) {
        return status === this.NOTIFICATION_TRANSLATION_STATUS_ENUM.KEYS.ACTIVE;
    }

    isCompanyLanguage (language) {
        return language.toUpperCase() === this.companyLanguage.toUpperCase();
    }

    getTag (variable) {
        return `{{ ${variable} }}`;
    }

    sortTranslations (templates) {
        const companyLanguages = this.TokenService.getCompanyLanguages();

        // This is a fixed order. Change this only if told so.
        const order = [
            this.COMPANY_LANGUAGE_ENUM.KEYS.RU,
            this.COMPANY_LANGUAGE_ENUM.KEYS.LV,
            this.COMPANY_LANGUAGE_ENUM.KEYS.LT,
            this.COMPANY_LANGUAGE_ENUM.KEYS.NO,
            this.COMPANY_LANGUAGE_ENUM.KEYS.FI,
            this.COMPANY_LANGUAGE_ENUM.KEYS.SV
        ];

        if (this.companyLanguage.toUpperCase() === this.COMPANY_LANGUAGE_ENUM.KEYS.ET) {
            order.unshift(this.COMPANY_LANGUAGE_ENUM.KEYS.ET, this.COMPANY_LANGUAGE_ENUM.KEYS.EN);
        }
        else {
            order.unshift(this.COMPANY_LANGUAGE_ENUM.KEYS.EN, this.COMPANY_LANGUAGE_ENUM.KEYS.ET);
        }
        const sortedList = [];
        this.lodash.forEach(order, orderLang => {
            this.lodash.forEach(templates, model => {
                model.language = model.language.toUpperCase();
                if (model.language === orderLang && this.lodash.includes(companyLanguages, orderLang)) {
                    sortedList.push(model);
                }
            });
        });

        return sortedList;
    }

    beforeSave () {
        this.templateForm.model.sendIcalFile = this.checked;
        this.templateForm.model.sendNotificationsForOptionalModule = this.checkedNotifications;
    }

    save () {
        this.beforeSave();
        this.form.save()
            .then(() => {
                this.form.saved = false; // This is set to false to avoid duplicate success messages in form wrapper
                this.templateForm.save()
                    .then(() => {
                        this.toastr.success(this.$translate.instant('notification.Templates saved successfully.'));
                    })
                    .catch(() => {
                        this.toastr.error(this.$translate.instant('general.There were errors processing the form'));
                        this.form.invalid = false; // This is set to false to avoid duplicate error messages in form wrapper
                    });
            })
            .catch(() => {
                this.toastr.error(this.$translate.instant('general.There were errors processing the form'));
                this.form.invalid = false; // This is set to false to avoid duplicate error messages in form wrapper
            });
    }

    preview (template) {
        this.previewTemplate = template;
        return this.ModalService.open({
            template: '<modals-template-preview template-i18n="vm.previewTemplate" class="wrapper" cancel="vm.$uibModalInstance.dismiss()"/>',
            controller ($uibModalInstance) {
                this.$uibModalInstance = $uibModalInstance;
                this.previewTemplate = template;
            }
        });
    }

    previewNotification (template) {
        this.previewTemplate = template;
        return this.ModalService.open({
            template: '<modals-template-preview-notification template-i18n="vm.previewTemplate" class="wrapper" cancel="vm.$uibModalInstance.dismiss()"/>',
            controller ($uibModalInstance) {
                this.$uibModalInstance = $uibModalInstance;
                this.previewTemplate = template;
            }
        });
    }

    confirmDisablingTranslation (template) {
        if (!template.active) {
            template.status = this.NOTIFICATION_TRANSLATION_STATUS_ENUM.KEYS.INACTIVE;
            this.ModalService
                .confirm(
                    this.$translate.instant('template. Template will be sent in {companyLanguage} confirm.',
                    { companyLanguage: this.COMPANY_LANGUAGE_ENUM.LABELS[this.companyLanguage.toUpperCase()] }))
                .catch(() => {
                    template.active = !template.active;
                    template.status = this.NOTIFICATION_TRANSLATION_STATUS_ENUM.KEYS.ACTIVE;
                }
            );
        }
        else {
            template.status = this.NOTIFICATION_TRANSLATION_STATUS_ENUM.KEYS.ACTIVE;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/manage/templates/detail/index.js